import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SearchBar, Pagination } from "../../components";
import { getAllAds, setPage } from "../../store/slices/apiAdsSlice";
import TableItemsAds from "./TableItemsAds";
import TableAdsResponsive from "./TableAdsResponsive";
import AddAdsModal from "./AddAdsModal";
import { useRef } from "react";

const TableAds = () => {
  const dispatch = useDispatch();
  const dataPackages = useSelector((state) => state.apiAds.data);
  const totalCount = useSelector((state) => state.apiAds.totalCount);
  const currentPage = useSelector((state) => state.apiAds.currentPage);
  const [searchInput, setSearchInput] = useState("");
  const prevSearchRef = useRef("");

  useEffect(() => {
    const pageToUse =
      prevSearchRef.current !== searchInput ? 1 : currentPage;
  
    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1));
      prevSearchRef.current = searchInput;
    }
  
    dispatch(getAllAds({ page: pageToUse, searchQuery: searchInput }));
  }, [dispatch, currentPage, searchInput]);
  

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(getAllAds({ page: currentPage, searchQuery: searchInput }));
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  return (
    <div className="p-3">
      <div className="flex items-center justify-between pb-4 bg-white dark:bg-gray-900">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
        <div>
          <button
            className="text-blue-600 hover:text-blue-800 font-medium flex items-center gap-2"
            aria-label="Shto reklamë të re"
          >
            <AddAdsModal />
          </button>
        </div>
      </div>

      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <div className="hidden sm:block">
          <table className="w-full text-sm text-left text-gray-700 dark:text-gray-300">
            <thead className="text-xs uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Titulli
                </th>
                <th scope="col" className="px-6 py-3">
                  Përshkrimi
                </th>
                <th scope="col" className="px-6 py-3">
                  Kategoria
                </th>
                <th scope="col" className="px-6 py-3">
                  Statusi
                </th>
                <th scope="col" className="px-6 py-3">
                  Foto
                </th>
                <th scope="col" className="px-6 py-3">
                  Aksionet
                </th>
              </tr>
            </thead>
            <tbody>
              <TableItemsAds dataPackage={dataPackages} />
            </tbody>
          </table>
        </div>

        <div className="block sm:hidden space-y-4">
          <TableAdsResponsive dataPackage={dataPackages} />
        </div>
        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default TableAds;
